module.exports = __webpack_public_path__ + "img/chuky-moi2.ef7c3619.png";